import React from 'react';
import { marked } from 'marked';

import { Repeat } from '../../StyledComponents/Repeat';
import { ButtonInline } from '../../StyledComponents/Button';
import Modal from '../../StyledComponents/Modal';
import Content from '../../StyledComponents/Content';
import LogoBox from '../../StyledComponents/LogoBox';

interface ModelLink {
  href?: string | null;
  title?: string | null;
}

export interface PackageOptionModalData {
  title?: string | null;
  image?: string | null;
  description?: string | null;
  link?: ModelLink | null;
}

interface PackageOptionsModalProps {
  packageOption: PackageOptionModalData;
  onClose: () => void;
}

const PackageOptionModal = ({ packageOption, onClose }: PackageOptionsModalProps) => (
  <Modal title={packageOption.title || ''} onClose={onClose}>
    {packageOption.image && (
      <Repeat>
        <LogoBox logo={packageOption.image} alt={packageOption.title || undefined} wide />
      </Repeat>
    )}
    {packageOption.description && (
      <Repeat>
        <Content dangerouslySetInnerHTML={{ __html: marked(packageOption.description) }} />
      </Repeat>
    )}
    {packageOption.link?.href && packageOption.link.title && (
      <Repeat>
        <ButtonInline
          as="a"
          href={packageOption.link.href}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {packageOption.link.title}
        </ButtonInline>
      </Repeat>
    )}
  </Modal>
);

export default PackageOptionModal;
